import React, { FC } from 'react';

import { Box } from '@rover/kibble/core';
import useDeviceContext from '@rover/react-lib/src/context/useDeviceContext';
import usePageContext from '@rover/react-lib/src/context/usePageContext';
import AdminToolbar from '@rover/shared/js/ssr/BaseTemplate/AdminToolbar';
import AppInstallBanner from '@rover/shared/js/ssr/BaseTemplate/AppInstallBanner';
import GlobalAnnouncements from '@rover/shared/js/ssr/BaseTemplate/GlobalAnnouncements';
import NavBar from '@rover/shared/js/ssr/BaseTemplate/NavBar';
import SkipToMainContentLink from '@rover/shared/js/ssr/BaseTemplate/NavBar/SkipToMainContentLink';

import BHNavbarProvider, { useBHNavbarContext } from './context/BHNavbarContext';

const Header: FC = () => {
  const { suppressHeader } = usePageContext();
  const { isEmbedded } = useDeviceContext();
  const { isBrightHorizonsNavigation, navBarPaddingOffset } = useBHNavbarContext();

  if (suppressHeader) return null;

  return (
    <Box as="header" display={isEmbedded ? 'none' : 'initial'}>
      <SkipToMainContentLink />
      <AdminToolbar />
      {!isBrightHorizonsNavigation && <AppInstallBanner />}
      <Box
        display={['flex', 'block']}
        width={['100%', 'inherit']}
        flexDirection="column"
        sx={{
          paddingTop: navBarPaddingOffset,
        }}
      >
        <GlobalAnnouncements />
        <NavBar />
      </Box>
    </Box>
  );
};

const HeaderContainer: FC = () => {
  return (
    <BHNavbarProvider>
      <Header />
    </BHNavbarProvider>
  );
};

export default HeaderContainer;
